import React from 'react';
import { IMedia } from '../../types/media';
import useMediaContainerData from './useMediaContainerData';

interface IMediaSectionContainerProps {
  initialMediaItems?: IMedia[];
  profileId?: string;
  storeSlug?: string;
  categorySlug?: string;
  externalProps?: any;
  fetchMediaUrl?: string;
  itemsPerPage?: number;
  hideLoader?: boolean;
  component?: React.ComponentType<React.PropsWithChildren<any>>;
  children?: any;
}

const MediaSectionContainer: React.FC<IMediaSectionContainerProps> = ({
  initialMediaItems = [],
  profileId,
  storeSlug,
  categorySlug,
  externalProps = {},
  component: Component,
  fetchMediaUrl = '',
  children,
  hideLoader,
  itemsPerPage = 4,
}) => {
  const { media, totalMediaCount, fetchNextMediaSet } = useMediaContainerData({
    initialMediaItems,
    profileId,
    storeSlug,
    categorySlug,
    fetchMediaUrl,
    itemsPerPage,
    hideLoader,
  });

  return (
    (!!Component && (
      <Component
        onMediaNext={fetchNextMediaSet}
        totalMediaCount={totalMediaCount}
        media={media}
        {...externalProps}
      />
    )) ||
    (!!children &&
      typeof children === 'function' &&
      children({ media, totalMediaCount, fetchNextMediaSet })) ||
    null
  );
};
export default React.memo(MediaSectionContainer);
